import { useEffect } from "react";
import { ObjectSuperTypesEnum, ObjectTypesEnum } from "../enums";

const validTypes = [
    ObjectSuperTypesEnum.Row,
    ObjectSuperTypesEnum.RectTable,
    ObjectSuperTypesEnum.RoundTable,
];

const tableTypes = [
    ObjectSuperTypesEnum.RectTable,
    ObjectSuperTypesEnum.RoundTable,
];

const childValidTypes = [
    ObjectSuperTypesEnum.Seat,
    ObjectSuperTypesEnum.Table
]

const getSeatsFromObject = (object) => {
    if (!object?._objects) return [];

    return object._objects.flatMap((child) => {
        if (childValidTypes.includes(child.superType)) {
            return [child];
        }

        return [];
    });
};

const getTablesFromGroups = (groups) => {
    return groups
        .filter((group) => tableTypes.includes(group.superType))
        .flatMap((group) => {
            const table = group._objects?.find(
                (child) => child.superType === ObjectSuperTypesEnum.Table
            );
            if (!table) return [];
            table.set({ selectionType: group.selectionType });
            return [table];
        });
};

const getAllSeats = (canvas) => {
    const groups = canvas.getObjects(ObjectTypesEnum.Group);
    const relevantGroups = groups.filter((group) => validTypes.includes(group.superType));

    const tables = getTablesFromGroups(relevantGroups);
    const seats = relevantGroups
        .flatMap(getSeatsFromObject)
        .filter((child) => child.superType !== ObjectSuperTypesEnum.Table);

    return [...seats, ...tables];
};

export const useSeatsVisibility = (
    canvasRef,
    canZoomIn,
    isMapLoaded,
    onVisible,
    onHidden
) => {
    useEffect(() => {
        if (!isMapLoaded) return;

        const handler = canvasRef.current?.handler;
        if (!handler) return;

        const shouldShowSeats = !canZoomIn;
        const isAlreadyInSameState =
            handler.isInteractionEnabled === shouldShowSeats;

        if (isAlreadyInSameState) return;

        handler.isInteractionEnabled = shouldShowSeats;

        const canvas = handler.canvas;
        const seats = getAllSeats(canvas);
        const callback = shouldShowSeats ? onVisible : onHidden;

        seats.forEach((seat) => {
            callback?.(seat);
        });

        canvas.requestRenderAll();
    }, [canZoomIn, isMapLoaded]);
};
